import type { ReactNode } from 'react';

// Lesson seed content (migrations 0018 + 0025) embeds <strong>...</strong>
// markup for emphasis. The renderers used to print these as raw text
// because the body fields are plain strings rendered inside <p>. This
// helper splits a string on <strong> tokens and returns a node tree with
// real <strong> elements so the markup actually renders.
//
// Safe — input is from our own seed, but we still avoid
// dangerouslySetInnerHTML by constructing actual nodes. Only <strong> is
// supported (verified across every lesson seed file). If we add more
// markup in the future, extend the regex set rather than reaching for
// a full HTML parser.

export function richText(input: string | null | undefined): ReactNode {
  if (input == null) return null;
  if (input === '' || !input.includes('<strong>')) return input;
  const parts: ReactNode[] = [];
  const re = /<strong>([\s\S]*?)<\/strong>/g;
  let last = 0;
  let key = 0;
  let match: RegExpExecArray | null;
  while ((match = re.exec(input)) !== null) {
    if (match.index > last) parts.push(input.slice(last, match.index));
    parts.push(
      <strong key={key++} className="font-bold text-ink-900">
        {match[1]}
      </strong>,
    );
    last = match.index + match[0].length;
  }
  if (last < input.length) parts.push(input.slice(last));
  return parts;
}
